import { PortalResetPasswordRequest } from 'vopay';
import { useState } from 'react';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

// Consumes the token from the reset email. Shared with the client portal (POST /portal/reset-password).
export default function useResetPortalPassword() {
  const [submitting, setSubmitting] = useState(false);

  async function resetPassword(params: PortalResetPasswordRequest) {
    try {
      setSubmitting(true);
      const res = await api.postPortalResetPassword(params);

      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSubmitting(false);
    }
  }

  return { submitting, resetPassword };
}
